/* eslint-disable */
import { EuiIcon, EuiPanel, EuiSpacer, EuiTabbedContent } from "@elastic/eui";
import _, { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { userRoles } from "../../../../constants/userRoles";
import Api from "../../../../lib/api";
import { getAllComments } from "../../../shared/Comments/commentSlice";
import { initUsers } from "../../../shared/Comments/slice";
import { extractResourceAttributes } from "../../../../utils/jsonApiUtils";
import { getUserRoles, isSuperAdmin, logoutSuccess } from "../../../auth/slice";
import {
    fullPageLoaderSelector,
    hideLoader,
    showLoader,
} from "../../../shared/FullPageLoader/slice";
import { setMessage } from "../../../shared/notification/slice";
import { stateActionValue, tripSource } from "../../constants/tripStates";
import {
    activeTripSelector,
    adminsSelector,
    branchesSelector,
    confirmedTripsSelector,
    driverSelector,
    editTripFailure,
    fetchTrip,
    pointsSelector,
    suppliersSelector,
    truckSelector,
    truckTypeSelector,
    updateActiveTrip,
} from "../../slice";
import * as S from "../../style";
import TripRoute from "../Summary/TripRoute";
import SummaryView from "../Summary/view";
import TripHeaderView from "./TripHeaderView";
import trackAnalytics from "../../../../trackAnalytics";
import { ModalComponent } from "components";
import { EuiText } from "@elastic/eui";
import InfoIcon from "@mui/icons-material/Info";

const cancelledBy = (int) => ({
    ["supplier"]: int.formatMessage({
        id: "trip-actions.cancellation-reason-supplier-partner",
    }),
    ["supplier_client"]: int.formatMessage({
        id: "trip-actions.cancellation-reason-client",
    }),
});

// TODO: Refactor to use EditEntity from API slice
const updatePoint = async (pointId, pointField) => {
    if (pointField.id) {
        delete pointField.id;
    }

    const response = await Api.put(`/trip-points/${pointId}`, {
        data: {
            id: +pointId,
            type: "tripPoints",
            attributes: { ...pointField },
        },
    });
    return response;
};

const updatePoints = async (points) => {
    const updatePointsPromise = points.map(async (point) => await updatePoint(point.id, point));

    return Promise.all(updatePointsPromise);
};

const deletePoint = async (pointId) => {
    const response = await Api.delete(`/trip-points/${pointId}`);
    return response;
};

const duplicateTrip = async (tripId, pickupTime) => {
    try {
        const response = await Api.get(`/trips/${tripId}/duplicate?pickupTime=${pickupTime}`);
        if (response && response["entities"]["trips"]) {
            return _.values(response["entities"]["trips"])[0].id;
        }
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't duplicate trip`,
            isError: true,
        });
    }
};

const attachmentsUrl = `attachments`;

const appendPointAttachment = async (pointId, documents) => {
    const updateAttachmentsPromise = documents.map(async (document) => {
        const body = {
            data: {
                attributes: { document, attachedItemId: +pointId, attachedItemType: "TripPoint" },
                type: "attachments",
            },
        };

        const response = await Api.post(attachmentsUrl, body);
        return response;
    });

    return await Promise.all(updateAttachmentsPromise);
};

const deletePointAttachment = async (attachmentId) => {
    const response = await Api.delete(`${attachmentsUrl}/${attachmentId}`);
    return response;
};

const updateTripStatus = async (tripId, status) => {
    const { value, meta } = status;
    const { cancellationReason, cancelledBy } = meta;

    if (cancellationReason && cancelledBy) {
        await Api.put(`/trips/${tripId}`, {
            data: {
                id: +tripId,
                type: "trips",
                attributes: { ...meta },
            },
        });
    }

    const response = await Api.get(`/trips/${tripId}/update_status?status=${value}`);
    return response;
};

const confirmTripField = async (tripId, fieldName) => {
    const response = await Api.post("confirm-trips", {
        data: {
            type: "confirmTrips",
            attributes: {
                tripId,
                fieldName: _.snakeCase(fieldName),
            },
        },
    });
    return response;
};
const COMMENTS_PER_PAGE = 4;

export default function Trip() {
    const { id } = useParams();

    const dispatch = useDispatch();
    const intl = useIntl();
    const activeTrip = useSelector(activeTripSelector());
    const trip = extractResourceAttributes(activeTrip);
    const tripPoints = useSelector(pointsSelector());
    const confirmedTrips = useSelector(confirmedTripsSelector());
    const admins = useSelector(adminsSelector());
    const supplier = extractResourceAttributes(useSelector(suppliersSelector()));
    const driver = extractResourceAttributes(useSelector(driverSelector()));
    const truck = extractResourceAttributes(useSelector(truckSelector()));
    const branch = extractResourceAttributes(useSelector(branchesSelector()));
    const truckType = extractResourceAttributes(useSelector(truckTypeSelector()));
    const isPageLoading = useSelector(fullPageLoaderSelector());
    const isCurrentUserSuperAdmin = useSelector(isSuperAdmin());
    const getCurrentUserRoles = useSelector(getUserRoles());
    const isSupplierPartner = getCurrentUserRoles?.includes("supplier_partner_account_manager");
    const [isLoading, setIsLoading] = useState(false);
    const [isRouteEnhanced, setIsRouteEnhanced] = useState(false);
    const [isEnhanceRouteModalVisible, setIsEnhanceRouteModalVisible] = useState(false);
    const [isRouteEnhancingLoading, setIsRouteEnhancingLoading] = useState(false);
    const [routeEnhancingTimeout, setRouteEnhancingTimeout] = useState(null);
    // NOTE: only superAdmin and accountManager can edit completed trips
    // for accountManager only system generated trips
    const isCurrentUserAccountManager = getCurrentUserRoles.some(
        (role) => role === userRoles.ACCOUNT_MANAGER
    );
    const canCurrentUserEditTripsAfterCompleted =
        isCurrentUserSuperAdmin ||
        isSupplierPartner ||
        (isCurrentUserAccountManager && trip.source === tripSource.system);

    useEffect(() => {
        if (isCurrentUserSuperAdmin === null) {
            dispatch(logoutSuccess());
        }
    }, [dispatch, isCurrentUserSuperAdmin]);

    useEffect(() => {
        if (isRouteEnhancingLoading) {
            let timeout = 0;
            const interval = setInterval(() => {
                timeout += 1;
                setRouteEnhancingTimeout(timeout);
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [isRouteEnhancingLoading]);

    const tabs = [
        {
            id: "summary",
            name: (
                <span>
                    <EuiIcon
                        size="m"
                        style={{ marginRight: 8, marginTop: -5 }}
                        type="notebookApp"
                    />
                    <FormattedMessage id="trip.summary-section-title" />
                </span>
            ),
            content: (
                <SummaryView
                    canCurrentUserEditTripsAfterCompleted={canCurrentUserEditTripsAfterCompleted}
                    trip={trip}
                    tripPoints={tripPoints}
                    confirmedTrips={confirmedTrips}
                    admins={admins}
                    onDropoffsChange={handleDropoffs}
                    onPointFieldChange={handlePointField}
                    onDropoffDelete={handleDropoffDelete}
                    onTripDataChange={handleTripData}
                    onSupplierChange={handleSupplierChange}
                    onSupplierContractTypeChange={handleSupplierContractTypeChange}
                    onTagCounterChange={handleTagCountChange}
                    onConfirmingTripField={handleConfirmingTripField}
                    onMakeTripReturnable={handleMakeTripReturnable}
                />
            ),
        },
        {
            id: "trip-route",
            name: (
                <span>
                    <EuiIcon
                        style={{ marginRight: 8, marginTop: -2 }}
                        type="gisApp"
                    />
                    <FormattedMessage id="trip.route-section-title" />
                </span>
            ),
            content: (
                <TripRoute
                    trip={trip}
                    isRouteEnhanced={isRouteEnhanced}
                    handleRouteEnhancingStarting={() => setIsRouteEnhancingLoading(true)}
                    routeEnhancementSuccessCallback={() => {
                        setIsEnhanceRouteModalVisible(false);
                        setIsRouteEnhancingLoading(false);
                    }}
                />
            ),
        },
    ];

    useEffect(() => {
        if (id) {
            initialGetTrip();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    //* fetch trip information from the server
    const getTrip = () => {
        dispatch(
            fetchTrip(
                id,
                "driver,truck,order,supplier,tripPoints,tripPoints.attachments,tripType,truckType,order.branch,confirmedTrips,confirmedTrips.confirmedBy,project"
            )
        );
    };

    const initialGetTrip = async () => {
        dispatch(showLoader());
        await getTrip();
        await dispatch(initUsers());
        await dispatch(getAllComments(id, COMMENTS_PER_PAGE));

        dispatch(hideLoader());
    };

    const updateTrip = async (updatedAttributes, successCallBack) => {
        const tripEntityObject = { ...activeTrip[`_${trip.id}`] };
        const tripEntityAttributes = { ...updatedAttributes };
        const editedFieldName = Object.keys(tripEntityAttributes)[0];
        // Track value changes for mixpanel events
        const valueChangedFrom = trip[editedFieldName]?.toString() ?? null;
        const valueChangedTo = tripEntityAttributes[editedFieldName];
        try {
            await dispatch(updateActiveTrip(tripEntityObject, tripEntityAttributes));
            await trackAnalytics(`Edit trip ${editedFieldName} success`, {
                from: valueChangedFrom,
                to: valueChangedTo,
                tripId: trip.id,
            });
            await getTrip();
            successCallBack && successCallBack();
        } catch (error) {
            setIsLoading(false);
            dispatch(editTripFailure({ error }));
            dispatch(
                setMessage({
                    content: error,
                    title: `Couldn't fetch trip ${trip.id} from the server`,
                    isError: true,
                })
            );
            await trackAnalytics(`Edit trip ${editedFieldName} failed`, {
                from: valueChangedFrom,
                to: valueChangedTo,
                tripId: trip.id,
            });
            successCallBack && successCallBack();
        }
    };

    // * update active trip with attributes and post updates to server
    function handleTripData(data, successCallBack) {
        updateTrip(data, successCallBack);
    }

    async function handleDropoffs(tripChangedDropoffs, successCallBack) {
        const tripDropoffs = tripPoints
            .filter((point) => point.pointType === "dropoff")
            .map((point) => ({ ...point, id: +point.id }));

        const updatedPoints = tripChangedDropoffs.filter((changedPoint) => {
            const pointDefaultValue = tripDropoffs.find(
                (tripPoint) => tripPoint.id === changedPoint.id
            );

            return (
                changedPoint.id &&
                (changedPoint.locationId !== pointDefaultValue?.locationId ||
                    changedPoint.cityId !== pointDefaultValue?.cityId ||
                    changedPoint.locationCategoryId !== pointDefaultValue?.locationCategoryId)
            );
        });
        const createdPoints = tripChangedDropoffs.filter((changedPoint) => !changedPoint.id);

        if (createdPoints.length) {
            updateTrip(
                {
                    tripPoints: createdPoints,
                },
                successCallBack
            );
        }

        if (updatedPoints.length) {
            try {
                await updatePoints(updatedPoints);
                await updateSuccess();
            } catch (error) {
                await updateFail(error);
            }
        }
    }

    const updateSuccess = async () => {
        await getTrip();
        dispatch(
            setMessage({
                content: `Updated Successfully`,
                isError: false,
            })
        );
    };

    const updateFail = (error) => {
        dispatch(
            setMessage({
                content: error,
                title: `Couldn't update`,
                isError: true,
            })
        );
    };

    async function handleSupplierChange(selected, successCallBack) {
        try {
            handleTripData({
                ...selected,
                driverId: null,
                truckId: null,
            });
            await updateSuccess();
            successCallBack();
        } catch (error) {
            await updateFail(error);
            successCallBack();
        }
    }

    async function handleSupplierContractTypeChange(selected, successCallBack) {
        try {
            handleTripData({
                ...selected,
            });
            await updateSuccess();
            successCallBack();
        } catch (error) {
            await updateFail(error);
            successCallBack();
        }
    }

    async function handleTagCountChange(requestedCount, tag, successCallBack) {
        try {
            await Api.get(
                `/trips/${id}/tags_count?tag_name=${tag}&requested_tag_count=${requestedCount}`
            );
            await updateSuccess();
            successCallBack();
        } catch (error) {
            await updateFail(error);
            successCallBack();
        }
    }

    async function handleMakeTripReturnable(_data, successCallBack) {
        try {
            await Api.get(`/trips/${id}/make_returnable`);
            await updateSuccess();
            successCallBack();
        } catch (error) {
            await updateFail(error);
            successCallBack();
        }
    }

    async function handlePointField(pointField, pointId, successCallBack) {
        const fieldKey = Object.keys(pointField)[0];
        try {
            if (fieldKey === "attachment") {
                pointField.attachment.id
                    ? await deletePointAttachment(pointField.attachment.id)
                    : await appendPointAttachment(pointId, pointField.attachment);
            } else {
                await updatePoint(pointId, pointField);
            }
            await updateSuccess();
            successCallBack();
        } catch (error) {
            await updateFail(error);
            successCallBack();
        }
    }

    const handleTripStatus = async (status, successCallBack) => {
        try {
            (isCurrentUserSuperAdmin || isSupplierPartner) && status.value !== "cancel"
                ? await updateTrip({ status: stateActionValue(status.value) })
                : (await updateTripStatus(id, status)) && (await updateSuccess());
            successCallBack();
        } catch (error) {
            await updateFail(error);
            successCallBack();
        }
    };

    const handleTripDuplicate = async (finishCallback, pickupDate) => {
        setIsLoading(true);
        const formattedPickupDate = moment(new Date(pickupDate)).format();
        const response = await duplicateTrip(trip.id, formattedPickupDate);
        finishCallback(response);
        setIsLoading(false);
    };

    async function handleDropoffDelete(pointId) {
        try {
            await deletePoint(pointId);
            await updateSuccess();
        } catch (error) {
            await updateFail(error);
        }
    }

    async function handleConfirmingTripField(fieldName, finishCallback) {
        try {
            await confirmTripField(id, fieldName);
            await updateSuccess();
            finishCallback();
        } catch (error) {
            await updateFail(error);
            finishCallback();
        }
    }

    const onTabClick = (tab) => {
        if (tab.id === "trip-route") {
            trackAnalytics("Route Tab Clicks", {
                "Trip Source": trip.source,
                "Trip Status": trip.status,
                "Trip Id": trip.id,
                "Geofencing Status": trip.geofence,
                "Number Of Waiting Points": tripPoints.length,
                "Number Of Dropoffs": dropoffs().length,
            });
        }
    };

    const dropoffs = () => tripPoints.filter((tp) => tp.pointType === "dropoff");

    const dropoffsNames = () => dropoffs().map((tp) => tp.name || tp.address || tp.cityName);

    const tripPickupArrivalTime = () => {
        const pickupPoints = tripPoints.filter((tp) => tp.pointType === "pickup");
        return pickupPoints.length > 0 && pickupPoints[0].arrivalTime;
    };

    const tripPickupDepartureTime = () => {
        const pickupPoints = tripPoints.filter((tp) => tp.pointType === "pickup");
        return pickupPoints.length > 0 && pickupPoints[0].departureTime;
    };

    const tripLastDropoffDepartureTime = () => {
        const dropoffPoints = dropoffs();
        const lastDropoff = dropoffPoints && dropoffPoints.pop();
        return lastDropoff && lastDropoff.departureTime;
    };

    const tripDuration = () => {
        const arrivalTime = tripPickupArrivalTime();
        const departureTime = tripLastDropoffDepartureTime();
        return arrivalTime && departureTime
            ? moment(departureTime).diff(moment(arrivalTime)) / 1000
            : null;
    };

    const onOpenRouteEnhancementModal = () => {
        setIsEnhanceRouteModalVisible(true);
    };

    return (
        <S.TripWrapper>
            <S.TripHeaderPanel className="hero">
                <TripHeaderView
                    isCurrentUserSuperAdmin={isCurrentUserSuperAdmin}
                    tripStatues={trip.status}
                    tripTags={trip.tags}
                    tripId={trip.id}
                    tripCancellationReason={trip.cancellationReason}
                    tripCancelledBy={trip.cancelledBy}
                    supplierName={supplier.name}
                    driverName={driver.name}
                    truckPlateNumber={truck.plateNumber}
                    dropoffs={dropoffsNames()}
                    manualDistance={trip.manualDistance}
                    pickupArrivalTime={tripPickupArrivalTime()}
                    pickupDepartureTime={tripPickupDepartureTime()}
                    tripDuration={tripDuration()}
                    lastDropoffDepartureTime={tripLastDropoffDepartureTime()}
                    currentTripPointId={trip.currentTripPointId}
                    branchNameAr={branch.nameAr}
                    branchNameEn={branch.nameEn}
                    truckTypeAlias={truckType.alias}
                    contractType={trip.contractType}
                    onTripStatusChange={handleTripStatus}
                    onSelectTag={handleTripData}
                    onDuplicateAction={handleTripDuplicate}
                    isLoading={isLoading}
                    handleOpenRouteEnhancementModal={onOpenRouteEnhancementModal}
                />
            </S.TripHeaderPanel>
            <EuiSpacer />

            <React.Fragment>
                {trip.status === "cancelled" && (
                    <S.CancelTripWrapper dir={intl.locale === "ar" ? "rtl" : "ltr"}>
                        <div>
                            {intl.formatMessage(
                                { id: "trip-actions.cancellation-hint-title" },
                                { source: cancelledBy(intl)[trip?.cancelledBy] }
                            )}
                        </div>
                        {trip?.cancellationReason && (
                            <S.CancellationReasonWrapper>
                                <InfoIcon style={S.infoIconStyles} />{" "}
                                {trip?.cancellationReason || ""}
                            </S.CancellationReasonWrapper>
                        )}
                    </S.CancelTripWrapper>
                )}
            </React.Fragment>

            <EuiSpacer />
            <EuiPanel style={{ padding: 0 }}>
                {!isPageLoading && (
                    <EuiTabbedContent
                        tabs={tabs}
                        expand={false}
                        initialSelectedTab={tabs[0]}
                        autoFocus="selected"
                        onTabClick={(tab) => onTabClick(tab)}
                    />
                )}
            </EuiPanel>
            <ModalComponent
                open={isEnhanceRouteModalVisible}
                header={<h1>Enhance Route</h1>}
                isFooter={!isRouteEnhancingLoading && !isRouteEnhanced}
                cancelBtn
                submitBtn
                disabled={isRouteEnhancingLoading}
                submitBtnText="Enhance"
                onSubmit={() => setIsRouteEnhanced(true)}
                onClose={() => setIsEnhanceRouteModalVisible(false)}
                borderedHeader
            >
                <EuiText size="m">
                    {!isRouteEnhancingLoading && !isRouteEnhanced
                        ? "Route enhancement is a premium service."
                        : "Route is already enhanced."}
                </EuiText>
                {isRouteEnhancingLoading && (
                    <EuiText size="m">Cooldown time {routeEnhancingTimeout} sec</EuiText>
                )}
            </ModalComponent>
        </S.TripWrapper>
    );
}
